export default {
  revenueChartSeries(state) {
    if (!state.revenueOverTime) return [];
    return [{
      name: "Umsatz",
      data: state.revenueOverTime.map(item => ({
        x: item._id,
        y: Math.round(item.revenue * 100) / 100,
      })),
    }];
  },

  ordersChartSeries(state) {
    if (!state.revenueOverTime) return [];
    return [{
      name: "Bestellungen",
      data: state.revenueOverTime.map(item => ({
        x: item._id,
        y: item.orders,
      })),
    }];
  },

  peakHoursSeries(state) {
    if (!state.peakHours) return [];
    const hours = new Array(24).fill(0);
    state.peakHours.forEach(item => {
      hours[item._id] = item.orders;
    });
    return hours;
  },
}
